import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "script"
    }}>{`script`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v3.0`}</p>
    <p>{`Loads and executes a script.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/HTML/Element/script"
      }}>{`https://developer.mozilla.org/en/docs/Web/HTML/Element/script`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<script src="index.js"></script>    
`}</code></pre>
    <h2 {...{
      "id": "quirks"
    }}>{`Quirks`}</h2>
    <p>{`Note that while Photoshop will allow you to inject `}<inlineCode parentName="p">{`<script>`}</inlineCode>{` tags via the HTML5 DOM API and they `}<em parentName="p">{`will`}</em>{` execute, you should not rely on this behavior, as this can be a source of significant security risks. You should only use `}<inlineCode parentName="p">{`<script>`}</inlineCode>{` tags to load and execute local, static content.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      